export function truncateText(data, chars = 40) {
  if (!data) return '';
  if (typeof data !== 'string') data = data.toString();
  if (data.length < chars) return data;
  return data.substr(0, chars) + '...';
}